import { Button, Card, Form, Input, Layout, Row,Col, notification } from "antd";
import UserService from "../../services/UserService";
import { useNavigate, useSearchParams } from "react-router-dom";

interface LoginPageProps {
  onSuccess?: (token: string) => void;
}

function LoginPage(props: LoginPageProps) {
  const [searchParams] = useSearchParams();
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const onFinish = (values: any) => {
    UserService.login(values["username"], values["password"])
      .then(() => {
        const redirectTo = searchParams.get("redirectTo");
        if (redirectTo) {
          navigate(redirectTo);
        } else {
          navigate("/orders");
        }
      })
      .catch((error) => {
        if (error.status === 404) {
          api["error"]({
            message: <strong>Credenciales incorrectas</strong>,
            description:
              "El usuario y/o contraseña ingresados son incorrectos.",
            style: { backgroundColor: "#fff2f0", border: "1px solid #ffccc7" },
          });
        } else {
          api["error"]({
            message: <strong>Oops! Halgo salió mal...</strong>,
            description: "Por favor, intente más tarde.",
            style: { backgroundColor: "#fff2f0", border: "1px solid #ffccc7" },
          });
        }
      });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Layout
      style={{
        height: "100vh",
        width: "100vw",
        margin: "auto",
        display: "table",
        textAlign: "center",
      }}
    >
      {contextHolder}
      <Layout.Content
        style={{
          height: "100%",
    width: "100%",
    margin: "auto",
    display: "table",
    textAlign: "center",
    backgroundImage: `url("/background-image.jpg")`,
    backgroundSize: "cover",        // hace que cubra todo el contenedor
    backgroundRepeat: "no-repeat",  // evita repeticiones
    backgroundPosition: "center",   // centra la imagen SIEMPRE
        }}
      >
        <Row
          justify="center"
          align="middle"
          style={{
            height: "100%",
            flexDirection: "column"
          }}
          
        >
        <img
    src="/distribuidora_integrall.png" // 👈 cambiá "logo.png" por el nombre de tu imagen
    alt="Logo"
    style={{ width: "200px", marginBottom: "20px" }}
  />
            <Form
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Usuario"
                name="username"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Contraseña"
                name="password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type="primary" htmlType="submit">
                  Acceder
                </Button>
              </Form.Item>
            </Form>
          
        </Row>
      </Layout.Content>
    </Layout>
  );
}

export default LoginPage;
